import React, { useEffect, useState } from "react";
import {
  Portlet,
  PortletHeader,
  PortletHeaderToolbar
} from "../../../../components/Portlet";
import { connect } from "react-redux";
import {
  DeleteItem,
  GetItem,
  UpdateItem
} from "../../../../redux/actions/base";
import { AirlineListRoute } from "../../../routesConstants";
import { useParams } from "react-router-dom";
import BlockUi from "@availity/block-ui";
import { Dropdown, Row, Col } from "react-bootstrap";
import DropdownButton from "react-bootstrap/DropdownButton";
import AirlineForm from "../components/airlineForm";
import {Helmet} from "react-helmet";
import _ from "lodash"

const AirlineEditPage = props => {
  const [airline, setAirline] = useState(null);
  const [loader, setLoader] = useState(false);
  const { id } = useParams();
  useEffect(() => {
    if (airline === null) {
      setLoader(true);
      props.GetItem("/api/air/airlines", id, res => {

        setAirline({...res.data.data, classes: _.sortBy(res.data.data.classes, c => c.classLetter)});
        setLoader(false);
      });
    }
  }, [airline, id, props]);
  const callback = (values, cb) => {
    props.UpdateItem("/api/air/airlines/" + id, values, cb, AirlineListRoute);
  };
  const deleteAction = () => {
    setLoader(true);
    props.DeleteItem("/api/air/airlines/" + id, () => {}, AirlineListRoute);
  };
  console.log('airl', airline)
  return (
    <>
      <Helmet>
        <title>{airline?.name || 'Авиакомпания'}</title>
      </Helmet>
      <Row>
        <Col lg={6}>
          <Portlet>
            <PortletHeader
              title={"Редактирование аивакомпании"}
              toolbar={
                <PortletHeaderToolbar>
                  <BlockUi blocking={loader}>
                    <DropdownButton variant="outline-danger" title="Удалить">
                      <Dropdown.Item as="button" onClick={deleteAction}>
                        Да! Удалить
                      </Dropdown.Item>
                    </DropdownButton>
                  </BlockUi>
                </PortletHeaderToolbar>
              }
            />
            <BlockUi blocking={loader}>
              <AirlineForm onSubmit={callback} data={airline} />
            </BlockUi>
          </Portlet>
        </Col>
      </Row>
    </>
  );
};

export default connect(null, { GetItem, UpdateItem, DeleteItem })(
  AirlineEditPage
);
